import type { AssetTemplate } from '~/modules/shopify/types';

export const isExistingPageAssigned = (asset: AssetTemplate) => {
  if (!asset.assigned) return false;

  return asset.assigned.total > 0;
};
